module.exports = __webpack_public_path__ + "img/thomas-bg.b5de5d29.png";